export default function BackgroundImage(el) {
	let img = el.querySelector('img');

	if (img) {
		el.style.backgroundImage = `url(${img.src||img.dataset.cfsrc})`;
		img.style.display        = 'none';
	}
}
